import type { UserProfile } from "@/types/auth";
import { isElevatedRole } from "./roles";

const DISABLE_AUTH = import.meta.env.VITE_DISABLE_AUTH === "true";

/**
 * Gate for the expert-only generation internals viewer (attempt timeline,
 * per-step feedback). Mirrors the backend's expert gate on
 * GET /blog-creation/content/{id}/generation-timeline: platform role only —
 * expert or an elevated platform role. No email allowlist.
 */
export function canViewGenerationInternals(
	userProfile: Pick<UserProfile, "platform_role"> | null | undefined,
): boolean {
	if (DISABLE_AUTH) return true;

	const platformRole = userProfile?.platform_role;
	return platformRole === "expert" || isElevatedRole(platformRole);
}
